import React from "react";

import LessonFragmentsList from "./LessonFragmentsList";
import LessonBlockList from "./LessonBlockList";
import LessonBlockEditorPanel from "./LessonBlockEditorPanel";

export default function LessonEditor({
                                         contentJson,
                                         selectedFragmentId,
                                         selectedBlockId,
                                         selectedFragment,
                                         selectedBlock,
                                         setSelectedFragmentId,
                                         setSelectedBlockId,
                                         setContentJson,
                                         updateFragment,
                                         updateBlock,
                                         setConfirm,
                                         courseId
                                     }) {

    const handleFragmentsChange = (fragments) => {
        setContentJson((prev) => ({
            ...prev,
            fragments,
        }));
    };

    const handleBlocksChange = (blocks) => {
        updateFragment(selectedFragmentId, (fragment) => ({
            ...fragment,
            blocks,
        }));
    };

    const handleBlockChange = (patch) => {
        updateBlock(
            selectedFragmentId,
            selectedBlockId,
            (block) => ({
                ...block,
                ...patch,
                config: {
                    ...(block.config || {}),
                    ...(patch.config || {}),
                },
            })
        );
    };

    return (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">

            {/* FRAGMENTS */}
            <div className="lg:col-span-3 bg-white rounded-2xl border p-4">
                <LessonFragmentsList
                    fragments={contentJson?.fragments || []}
                    selectedFragmentId={selectedFragmentId}
                    onSelect={setSelectedFragmentId}
                    onChange={handleFragmentsChange}
                    onDeleteRequest={(id) =>
                        setConfirm({
                            type: "fragment",
                            id,
                            message: "این فرگمنت و تمام بلاک‌های آن حذف می‌شود.",
                        })
                    }
                />
            </div>

            {/* BLOCKS */}
            <div className="lg:col-span-4 bg-white rounded-2xl border p-4">
                <LessonBlockList
                    fragment={selectedFragment}
                    selectedBlockId={selectedBlockId}
                    onSelect={setSelectedBlockId}
                    onChange={handleBlocksChange}
                    onDeleteRequest={(id) =>
                        setConfirm({
                            type: "block",
                            id,
                            message: "این بلاک حذف می‌شود.",
                        })
                    }
                />
            </div>


            {/* BLOCK EDITOR */}
            <div className="lg:col-span-5 bg-white rounded-2xl border p-4">
                <LessonBlockEditorPanel
                    courseId={courseId}
                    fragmentId={selectedFragmentId}
                    block={selectedBlock}
                    onChange={handleBlockChange}
                />
            </div>
        </div>
    );
}
